// 不使用微信内支付的域名
export const noWechatPayDomain = ['https://mtrip.gdcts.com', 'https://uatmtrip.gdcts.com'];
